export default __webpack_public_path__ + "static/media/tete83.2ca80402.png";